import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Elements } from '@stripe/react-stripe-js';
import { useLoadStripe } from '../../../../hooks/useLoadStripe';
import { apiPostMultiPaymentIntentApi } from '../../../../helpers/api';
import {
  imagePaymentFormPopupActions,
  selectClientSecretKey,
  selectDisabledRenderJobId,
  selectIsAmountForRenderSufficient,
  selectIsPaymentFormActive,
  selectIsStripeLoading,
  selectOrgAvailableBalance,
  selectRemainingAmountForRender,
} from '../../../../redux/slicers/imagePaymentFormPopupSlicer';
import { PaymentCheckoutForm } from './PaymentCheckoutForm';
import { dispatcher } from '../../../../helpers/projectHelper';
import { getAppState } from '../../../../redux/store';
import { errorToast } from '../../../../helpers/toastHelper';
import Loader from '../../../Loader/Loader';

const PAYMENT_METHODS = ['card'];

export const createNsetClientSecretKey = async () => {

  const renderJobId = selectDisabledRenderJobId(getAppState());
  const remainingAmount = selectRemainingAmountForRender(getAppState());
  const availableBalance = selectOrgAvailableBalance(getAppState());
  const isRenderAmountSufficient = selectIsAmountForRenderSufficient(getAppState());

  dispatcher(imagePaymentFormPopupActions.setIsStripeLoading(true));
  const paymentTypes = PAYMENT_METHODS?.map((val) => val).join('&payment_method_types=');
  const res = await apiPostMultiPaymentIntentApi(
    remainingAmount,
    paymentTypes,
    renderJobId,
    isRenderAmountSufficient,
    availableBalance
  );
  if (!res?.clientSecret) {
    dispatcher(imagePaymentFormPopupActions.setClientSecretKey(null));
    dispatcher(imagePaymentFormPopupActions.setIsStripeLoading(false));
    dispatcher(imagePaymentFormPopupActions.close());
    errorToast("Unable to create clientSecret key.")
    return;
  }
  dispatcher(imagePaymentFormPopupActions.setClientSecretKey(res?.clientSecret));

}

export const PaymentFormForImages = () => {
  const dispatch = useDispatch();
  const isActive = useSelector(selectIsPaymentFormActive);
  const { stripePromise } = useLoadStripe();

  const clientSecret = useSelector(selectClientSecretKey);
  const isStripeLoading = useSelector(selectIsStripeLoading);

  const appearance = {
    theme: 'stripe',
  };
  const options = {
    clientSecret,
    appearance,
  };
  
  const closePopup = () => {
    dispatch(imagePaymentFormPopupActions.close());
  };

  if(!isActive || !clientSecret) return null;

  return (
    <Modal
      show={Boolean(isActive)}
      backdrop="static"
      onHide={() => closePopup()}
      size="lg"
      centered={true}
      animation
      backdropClassName="dark-bd">
      <Modal.Body>
        <div style={{
          minHeight: 275,
          position: 'relative'
        }}>
          {
            isStripeLoading ? (
              <Loader loading style={{ 
                minHeight: '275px',
                position: 'absolute',
                zIindex: 1000,
                left: 0,
                top: 0,
                width: '100%',
                background: '#fff',
                height: '100%',
              }} 
              />
            ) : null
          }
          <Elements options={options} stripe={stripePromise}>
            <PaymentCheckoutForm clientSecret={clientSecret} />
          </Elements>
        </div>
      </Modal.Body>
    </Modal>
  );
};
